var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDownLightV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Arrows / Arrow Up",
    clipPath: "url(#clip0_7979_281538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88095 7.73252C4.78332 7.83016 4.62502 7.83016 4.52739 7.73252L2.52739 5.73252C2.42976 5.63489 2.42976 5.4766 2.52739 5.37897C2.62502 5.28134 2.78332 5.28134 2.88095 5.37897L4.45417 6.95219L4.45417 2.22241C4.45417 2.08434 4.5661 1.97241 4.70417 1.97241C4.84224 1.97241 4.95417 2.08434 4.95417 2.22241L4.95417 6.95219L6.52739 5.37897C6.62502 5.28134 6.78332 5.28134 6.88095 5.37897C6.97858 5.4766 6.97858 5.63489 6.88095 5.73252L4.88095 7.73252Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7979_281538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.702705 0.889648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDownLightV2);
export default __webpack_public_path__ + "static/media/icon-arrow-down-light-v2.51f3b989637b8055d6a9559593580fd8.svg";
export { ForwardRef as ReactComponent };